// Report freshness: the clock mark of the server's most recent score-processing
// run, shared by every report surface. See CLAUDE.md "Client state ... store".
import dayjs from 'dayjs';

import { createStore } from './create-store';

// The server reprocesses scores every 10 minutes, on the :00/:10/:20/:30/:40/:50 marks.
export const REPORT_REFRESH_MINUTES = 10;

const lastCheckMark = () => {
  const now = dayjs();
  return now.subtract(now.get('minute') % REPORT_REFRESH_MINUTES, 'minute').startOf('minute');
};

const [useReportsLastChecked, getReportsLastChecked, setReportsLastChecked] = createStore(lastCheckMark());
export { useReportsLastChecked };

// Re-derive each minute, publishing only when the window rolls over so the
// intervening ticks don't re-render every consumer.
setInterval(() => {
  const mark = lastCheckMark();
  if (!mark.isSame(getReportsLastChecked())) setReportsLastChecked(mark);
}, 60 * 1000);
